import script from "./Cabinet.vue?vue&type=script&setup=true&lang=js"
export * from "./Cabinet.vue?vue&type=script&setup=true&lang=js"

import "./Cabinet.vue?vue&type=style&index=0&id=7feb9572&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7feb9572"]])

export default __exports__